'use client'
import congtadulation from "@/utils/loading/congtadulation.json";

import Lottie from 'lottie-react';
import { useEffect } from 'react';

export default function Congrate() {
    function sendActionToApp(action: "rate") {
        if (window.webkit && window.webkit.messageHandlers.buttonClickHandler) {
            // Post the action to the app
            window.webkit.messageHandlers.buttonClickHandler.postMessage(action);
        } else {
            console.error("buttonClickHandler is not available.");
        }
    }

    useEffect(() => {

        sendActionToApp('rate')
    }, [])

    return (
        <Lottie
            className="max-w-64 h-28"
            animationData={congtadulation}
            loop={true}
        />
    );
}